import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const FinalCta = ({ onAudit }) => {
  return (
    <>
      <section data-testid="final-cta-section" className="relative py-16 sm:py-24 bg-[#12203c] overflow-hidden">
        <div className="absolute inset-0 stars-bg opacity-50 pointer-events-none" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full bg-[#fba31b]/10 blur-[140px] pointer-events-none" />
        <div className="orbit-ring hidden md:block w-[520px] h-[520px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <p className="font-code text-xs sm:text-sm uppercase tracking-[0.25em] text-[#fba31b] font-bold">Out of the World Creative</p>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
              Ready to elevate your <span className="text-[#fba31b]">property marketing?</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-xl mx-auto">
              Get a free audit of your current social media and one sample reel — on us. No obligation, no lock-in.
            </p>
            <button
              data-testid="final-audit-btn"
              onClick={onAudit}
              className="animate-pulse-glow mt-9 inline-flex items-center gap-2 bg-[#fba31b] hover:bg-[#e59312] text-[#12203c] font-bold px-8 py-4 rounded-full text-sm sm:text-base transition-colors"
            >
              Book a Free Audit + Sample Reel <ArrowRight className="w-5 h-5" />
            </button>
          </motion.div>
        </div>
      </section>

      <footer data-testid="site-footer" className="bg-[#0b1426] border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            <div>
              <img src="/assets/webastra-wordmark-light.webp" alt="Webastra" className="h-8 w-auto" />
              <p className="mt-3 font-code text-[10px] uppercase tracking-[0.3em] text-[#fba31b]/80">Out of the World</p>
              <p className="mt-3 text-sm text-slate-400 max-w-sm">
                The real estate creative studio for Dubai's boldest brokerages and developers.
              </p>
            </div>
            <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-nav">
              {[
                { label: "Packages", href: "#packages" },
                { label: "Sprint", href: "#sprint" },
                { label: "Process", href: "#process" },
                { label: "Why Us", href: "#why-us" },
                { label: "FAQs", href: "#faqs" },
              ].map((l) => (
                <a
                  key={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  href={l.href}
                  className="text-sm text-slate-300 hover:text-[#fba31b] transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
          <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-slate-500">© 2026 Webastra. All rights reserved.</p>
            <p className="text-xs text-slate-500">Dubai • UAE — Serving real estate brands worldwide</p>
          </div>
        </div>
      </footer>
    </>
  );
};
